// Centralized frontend environment config for easy switching between dev/prod
// Usage: import { API_BASE_URL, SOCKET_URL, ENV } from '../config/env';

const ENV = process.env.NODE_ENV || 'development';

// Normalize and derive sensible defaults
const rawApi = process.env.REACT_APP_API_BASE_URL || '/api';
const API_BASE_URL = rawApi.replace(/\/+$/, '');

const rawSocket = process.env.REACT_APP_SOCKET_URL || '';
// If not explicitly provided, try to infer from API_BASE_URL origin
const SOCKET_URL = rawSocket || (API_BASE_URL.startsWith('http')
  ? API_BASE_URL.replace(/\/api$/, '')
  : '');

export { API_BASE_URL, SOCKET_URL, ENV };
